import React, { useContext } from "react";
import { AccountStore } from "../../account/stores/AccountStore";
import { CraCommentStore } from "../../coding/stores/CraCommentStore";
import { CraNodeStore } from "../../cra/stores/CraNodeStore";
import { NotificationStore } from "../../notification/stores/NotificationStore";
import { DashboardStore } from "../../survey/stores/DashboardStore";
import { SurveyStore } from "../../survey/stores/SurveyStore";
import { MapStore } from "../../survey/stores/MapStore";
import { CraWayStore } from "../../cra/stores/CraWayStore";
import { CodingStore } from "../../coding/stores/CodingStore";
import { LoadingStore } from "../../survey/stores/LoadingStore";
import { FilterStore } from "../../survey/stores/FilterStore";
import { HlaStore } from "../../hla/stores/HlaStore";
import { AuthStore } from "../../auth/stores/AuthStore";
import { MapQueryStore } from "../../survey/stores/MapQueryStore";
import { MapillaryStore } from "../../survey/stores/MapillaryStore";
import { RouteDesignStore } from "../../survey/stores/RouteDesignStore";
import { StreetViewStore } from "./StreetViewStore";
import { CraForecastStore } from "../../survey/stores/CraForecastStore";
import { HlaForecastStore } from "../../survey/stores/HlaForecastStore";
import { OsmToolsStore } from "../../stores/OsmToolsStore";
import { SimulationStore } from "../../hla/stores/SimulationStore";

export class RootStore {
  authStore = new AuthStore();
  accountStore = new AccountStore(this);
  notificationStore = new NotificationStore(this);
  surveyStore = new SurveyStore(this);
  craWayStore = new CraWayStore(this);
  craNodeStore = new CraNodeStore(this);
  mapStore = new MapStore(this);
  dashboardStore = new DashboardStore(this);
  craForecastStore = new CraForecastStore(this);
  hlaForecastStore = new HlaForecastStore(this);
  craCommentStore = new CraCommentStore(this);
  codingStore = new CodingStore(this);
  loadingStore = new LoadingStore(this);
  filterStore = new FilterStore(this);
  hlaStore = new HlaStore(this);
  simulationStore = new SimulationStore(this);
  mapQueryStore = new MapQueryStore(this);
  routeDesignStore = new RouteDesignStore(this);
  mapillaryStore = new MapillaryStore(this);
  streetViewStore = new StreetViewStore(this);
  osmToolsStore = new OsmToolsStore(this);
}

interface ContextProps {
  authStore: AuthStore;
  accountStore: AccountStore;
  notificationStore: NotificationStore;
  surveyStore: SurveyStore;
  craWayStore: CraWayStore;
  craNodeStore: CraNodeStore;
  mapStore: MapStore;
  dashboardStore: DashboardStore;
  craForecastStore: CraForecastStore;
  hlaForecastStore: HlaForecastStore;
  craCommentStore: CraCommentStore;
  codingStore: CodingStore;
  loadingStore: LoadingStore;
  filterStore: FilterStore;
  hlaStore: HlaStore;
  simulationStore: SimulationStore;
  mapQueryStore: MapQueryStore;
  routeDesignStore: RouteDesignStore;
  mapillaryStore: MapillaryStore;
  streetViewStore: StreetViewStore;
  osmToolsStore: OsmToolsStore;
}
export const RootStoreContext = React.createContext({} as ContextProps);

export const useStores = () => useContext(RootStoreContext);

interface ProviderProps {
  children: React.ReactNode;
}
export const RootStoreProvider: React.FC<ProviderProps> = ({ children }) => {
  const rootStore = new RootStore();

  return (
    <RootStoreContext.Provider value={rootStore}>
      {children}
    </RootStoreContext.Provider>
  );
};
